import React from 'react';
import { FAQBox } from '@components/organisms/FAQBox/FAQBox';

export default function ContentElementFaqs(Element) {
  return <FAQBox faqs={Element.faqs} />;
}
